var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notify-box"},[_c('CustomNotifications',{attrs:{"notifications":_vm.notifications.notifications},on:{"remove-notification":_vm.removeNotification}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }